import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react';

if(['production', 'staging', 'multistaging'].includes(process.env.REACT_APP_ENV)) {
  Bugsnag.start({
    apiKey: '7f9959cd9103e34b16dd7d264c484bab',
    plugins: [new BugsnagPluginReact(React)],
    releaseStage: process.env.REACT_APP_ENV || 'development',
  });
}
